import moment from "moment";

/**
 * Tests if an email is associated with a development account using wildcards
 * and a list of development accounts that are not caught by the wildcards
 */
export const isTestAccount = (email, deviceLimitExceptionList = []) => {
  if (!email) return false;
  const must_not_terms = [/sb3d/, /3dsb/, /sportsbox/, /demo/, /_sb3d/];
  return (
    deviceLimitExceptionList?.includes(email) ||
    must_not_terms.some((term) => term.test(email))
  );
};

/**
 * Formats a timestamp to MM/DD/YYYY format
 */
export const dateFormatter = (date) => {
  return moment(String(date), "x").format("MM/DD/YYYY");
};

/**
 * Formats plan/product ID string to a readable format
 * Example: "sportsbox_pro_lite_monthly" -> "Sportsbox Pro Lite Monthly"
 */
export const planDetails = (str) => {
  if (!str) return "";
  str = str.replaceAll("_", " ");
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
};

/**
 * Capitalizes the first letter of a string
 */
export const capitalize = (s) => {
  return (s && s[0].toUpperCase() + s.slice(1)) || "";
};
